// BHP-1050: update the current account against Backend2.0 (PATCH merge-patch).
// On success the account bootstrap is invalidated so the UI reflects the change.
import {
  useMutation,
  type UseMutationResult,
  useQueryClient
} from '@tanstack/react-query';
import { type AccountPatch, updateAccount } from './accountApi';
import { accountKeys } from './useCurrentAccount';
import type { AccountData } from '../domain/accountData';

export function useUpdateAccount(
  uuid: string
): UseMutationResult<AccountData, unknown, AccountPatch> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: AccountPatch) => updateAccount(uuid, patch),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: accountKeys.current });
    }
  });
}
